import React from 'react';
import { BizonScreenWrapper, Title } from 'components/commons';
import completeIcon from './assets/complete.svg'
import './assets/partner-document-completed.scss'

type PartnerDocumentCompletedProps = {
    name: string;
};

const PartnerDocumentCompleted: React.FC<PartnerDocumentCompletedProps> = ({ name }): JSX.Element => (
    <BizonScreenWrapper>
        <div className="l-documents-screen grid-container">
            <div className="l-documents-screen__content">
                <Title className="mb-4">
                    Obrigado {name}!
                </Title>

                <div className="l-partner-document-completed">
                    <img
                        src={completeIcon}
                        alt="Documento enviado"
                    />
                    <h2>Documento enviado para <br />análise com sucesso.</h2>
                    <p>Avisaremos seu sócio que você já enviou seu documento.</p>
                </div>
            </div>
        </div>
    </BizonScreenWrapper>
);

export default PartnerDocumentCompleted;
